import { useMutation } from 'query';
import { downloadReport } from '../../services';

export const useDownloadReportMutation = () =>
  useMutation<Blob, { activityId: string }>({
    async mutationFn({ activityId }) {
      const response = await downloadReport({ routeParams: { id: activityId } });

      return new Blob([response.data]);
    },
  });
